import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import { LoadingSpinner } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';

import { PlainModal } from '@/components/modals/plain-modal';

import { DesktopModalContent } from './desktop';
import { MobileModalContent } from './mobile';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PiReadyStockModal: Component = ({
  modelThumbnail,
  fullName,
  piDealerListData,
  submodelList,
  modelId,
  isOpen,
  dealerId,
  onClose,
}) => {
  const { isIpadMini } = useScreenDetect();
  const isIpageMiniMode = isIpadMini();

  const filteredDealerListData = dealerId
    ? piDealerListData?.filter(dealer => dealer.id === dealerId)
    : piDealerListData;

  if (!piDealerListData) {
    return (
      <PlainModal
        className={cx(
          styles.containerRoot,
          styles.isMediumModal,
        )}
        isOpen={isOpen}
        onClose={onClose}>
        <div className={styles.containerLoadingSpinner}>
          <LoadingSpinner />
        </div>
      </PlainModal>
    );
  }

  return (
    <PlainModal
      className={styles.containerPricelistModal}
      contentClassName={cx(
        styles.containerContent,
        styles.isWidePadding,
      )}
      isOpen={isOpen}
      onClose={onClose}>
      {isIpageMiniMode
        ? (
          <DesktopModalContent
            fullName={fullName}
            modelId={modelId}
            modelThumbnail={modelThumbnail}
            piDealerListData={filteredDealerListData || piDealerListData}
            submodelList={submodelList} />
        )
        : (
          <MobileModalContent
            fullName={fullName}
            modelId={modelId}
            modelThumbnail={modelThumbnail}
            piDealerListData={filteredDealerListData || piDealerListData}
            submodelList={submodelList} />
        )}
    </PlainModal>
  );
};
